/**
 * Settings → Strata AI。菜单明文 Strata AI。
 * 打开页面打 STATSIG.COMMON.VIEW，value=settings_strata_ai。
 * 侧栏 /app/mortgagegpt 是另一页，value=strata_ai。
 *
 * 正在用：选回答风格，点了立刻保存。
 * 已不算：GuidelineGPT 自己的埋点。
 */
export enum SettingsStrataAIEvent {
    /**
     * 选回答风格，立刻保存。
     * value 与 metadata.audience 相同：loan_officer|underwriter
     */
    ANSWER_STYLE = 'STRATA_AI_ANSWER_STYLE',
}
